import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedBestMovementService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getBestMovements(departmentType) {
        const body = this.setBody();
        body.set('departmentType', departmentType);

        return this.http.post(this.urlService + this.routeAdress.route_ranking_best_movements, body.toString()).pipe(
            map(this.extractData),
            map((response) => response.registers),
            catchError(this.serviceError)
        );
    }
}
